import { backendApi, Result } from "./backendApi";

export interface FuelTypeModel {
  id?: number;
  type?: string;
  english?: string;
  dutch?: string;
  german?: string;
  french?: string;
  spanish?: string;
  portugues?: string;
  italian?: string;
  polish?: string;
  czech?: string;
  swedish?: string;
  danish?: string;
  norwegian?: string;
  finnish?: string;
  hungarian?: string;
  croatian?: string;
  hebrew?: string;
  slovene?: string;
  russian?: string;
  arabic?: string;
  ukrainian?: string;
}

class GetFuelTypesRequest {}

class GetFuelTypesResponse {
  fuelTypes?: FuelTypeModel[];
}

export const fuelTypeApi = {
  async getFuelTypes(): Promise<Result<FuelTypeModel[]>> {
    let response =
      await backendApi.sendAndGetResponseAsync<GetFuelTypesResponse>(
        "GetFuelTypes",
        new GetFuelTypesRequest(),
      );

    if (response.ok) {
      return { ok: true, value: response.value.fuelTypes ?? [] };
    }

    return response;
  },
};
